export default "__VITE_ASSET__FGSlxSvr__"